import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "@/context/CartContext";

const Navbar = () => {
  const { count, setDrawerOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  const links = [
    { label: "Le Masque", href: "/produit" },
    { label: "La Collection", href: "/#collection" },
    { label: "Le Rituel", href: "/#rituel" },
    { label: "Avis", href: "/#avis" },
    { label: "FAQ", href: "/#faq" },
  ];

  const go = (href) => {
    setMobileOpen(false);
    if (href.startsWith("/#")) {
      const id = href.slice(2);
      if (window.location.pathname !== "/") {
        navigate("/");
        setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 300);
      } else {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(href);
      window.scrollTo(0, 0);
    }
  };

  return (
    <header className="fixed top-9 left-0 right-0 z-50 backdrop-blur-md bg-[#FAF7F2]/80 border-b border-blush-deep/60">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand-link" className="font-serif text-2xl sm:text-3xl font-medium tracking-tight text-onyx">
          Relax<span className="text-rose-gold">.</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              onClick={() => go(l.href)}
              className="text-sm font-medium text-muted-warm hover:text-terracotta transition-colors tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cart-button"
            onClick={() => setDrawerOpen(true)}
            className="relative flex items-center gap-2 rounded-full bg-onyx text-cream px-4 sm:px-5 py-2.5 text-sm font-medium hover:bg-terracotta transition-colors"
          >
            <ShoppingBag size={17} strokeWidth={1.8} />
            <span className="hidden sm:inline">Panier</span>
            <span
              data-testid="nav-cart-count"
              className="absolute -top-1.5 -right-1.5 bg-rose-gold text-onyx text-[11px] font-mono font-bold w-5 h-5 rounded-full flex items-center justify-center"
            >
              {count}
            </span>
          </button>
          <button
            data-testid="nav-mobile-menu-button"
            className="md:hidden text-onyx p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {mobileOpen && (
        <div className="md:hidden bg-[#FAF7F2] border-t border-blush-deep px-5 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              onClick={() => go(l.href)}
              className="text-left text-base font-medium text-onyx py-1"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default Navbar;
